import { createStyles, makeStyles } from "@mui/styles";

const sharedDateBoxStyles = {
  height: 32,
  borderRadius: 2,
  backgroundColor: "#ffffff !important",
  border: "solid 1px #828282",
  "&.dx-texteditor.dx-editor-filled .dx-texteditor-input": {
    color: "#1E1E1E",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    fontFamily: "Segoe UI",
    padding: 8
  },
  "& input::placeholder": {
    color: "#6E6E6E !important",
    fontSize: "12px !important",
    fontWeight: 400,
    lineHeight: "16px",
    fontFamily: "Segoe UI !important",
    fontStyle: "italic",
    padding: 8
  },
  "&.dx-daterangebox .dx-texteditor-label": {
    color: "#6E6E6E !important",
    fontSize: "12px !important",
    fontWeight: 400,
    lineHeight: "16px",
    fontFamily: "Segoe UI !important",
    fontStyle: "italic",
    padding: 8
  },
  "&.dx-daterangebox .dx-daterangebox-separator": {
    paddingLeft: 0
  },
  "&.dx-dropdowneditor-icon": { color: "#464646" },
  "&.dx-texteditor.dx-editor-filled .dx-placeholder::before": {
    content: "none"
  },
  "&.dx-texteditor.dx-state-hover": {
    border: "solid 2px #828282"
  },
  "&.dx-texteditor.dx-state-focused": {
    border: "solid 2px #0F789B"
  },
  "&.dx-texteditor.dx-state-focused::before": {
    borderBottom: "none"
  },
  "&.dx-daterangebox .dx-texteditor.dx-state-focused::before": {
    borderBottom: "none !important"
  },
  "&.dx-texteditor.dx-editor-filled::after": {
    borderBottom: "none",
    bottom: 0
  },
  "&.dx-daterangebox .dx-icon-to": {
    display: "flex",
    alignItems: "center"
  },
  "&.dx-daterangebox .dx-icon-to::before": {
    content: `"-"`,
    fontSize: 12,
    fontWeight: 400,
    color: "#1E1E1E"
  }
};

export const useDatePickerStyles = makeStyles(() =>
  createStyles({
    dateBox: {
      ...sharedDateBoxStyles
    },
    dateBoxWithError: {
      ...sharedDateBoxStyles,
      border: "1px solid #DC0000",
      backgroundColor: "#DC00001A !important"
    },
    dateBoxDropDown: {
      "&.dx-daterangebox.dx-dropdowneditor-active .dx-dropdowneditor-icon::before":
        {
          color: "#464646"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar":
        {
          height: 315,
          width: 285
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar-body thead th":
        {
          color: "rgba(0, 0, 0, 0.54)",
          fontSize: "90%",
          fontWeight: "bolder"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-button-mode-text.dx-button-default":
        {
          fontSize: 12,
          fontWeight: 400,
          color: "#1E1E1E",
          border: "solid 1px #828282"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-button.dx-button-has-icon:not(.dx-button-has-text):not(.dx-shape-standard)":
        {
          border: "none"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-button.dx-button-has-icon.dx-state-hover":
        {
          backgroundColor: "#FFFFFF",
          color: "#dc6914"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar-navigator-next-month":
        {
          backgroundColor: "#FFFFFF",
          color: "#dc6914"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar-navigator-previous-view.dx-button .dx-icon,.dx-calendar-navigator-next-view.dx-button .dx-icon":
        {
          color: "#464646",
          height: 16,
          width: 16,
          fontSize: 16
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar-cell span":
        {
          height: 39,
          width: 39,
          fontSize: 12,
          borderRadius: "50%"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar-cell-range-hover::after":
        {
          border: "none"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar-cell.dx-calendar-other-view":
        {
          color: "rgba(57, 57, 57, 0.3)",
          backgroundColor: "transparent"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar-cell.dx-calendar-other-view.dx-state-hover span":
        {
          backgroundColor: "#e6e6e6",
          borderColor: "#e6e6e6"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar-cell.dx-state-hover span":
        {
          backgroundColor: "#daecf0"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar-cell-in-range::before":
        {
          backgroundColor: "#ffffff",
          border: "none"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar-cell.dx-calendar-today span":
        {
          border: "1px solid #dc6914",
          color: "#dc6914"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar-cell.dx-calendar-selected-date span":
        {
          backgroundColor: "#005f87",
          outlineOffset: "1px"
        },
      "&.dx-dropdowneditor-overlay.dx-popup-wrapper .dx-overlay-content .dx-calendar-cell.dx-calendar-contoured-date span":
        {
          boxShadow: "none"
        }
    }
  })
);
